import { allowedBackButtonRoutes } from '@core/constants/backButtonNavigation';
import { push } from 'react-router-redux';
import { operations } from '../../store/conversations';

const selectConversation = (conversationId, source) => (dispatch, getState) => {
  // Current state tree
  const state = getState();
  // Check if feature flag is enabled or not
  const isFtEnabled =
    state?.institution?.features?.webAppFtResponsiveMessages202506 || false;

  const getNewPath = (appState, chatId, isFeatureToggleEnabled) => {
    // Check if feature toggle is enabled or not
    if (isFeatureToggleEnabled) {
      const spaceId = appState?.classRoom?.current;
      if (!spaceId) {
        throw new Error('SpaceId is not found');
      }
      return `/dashboard/${spaceId}/messages/${chatId}`;
    }
    return appState?.routing?.locationBeforeTransitions?.pathname;
  };

  const pathname = getNewPath(state, conversationId, isFtEnabled);

  const query = {};

  if (source && allowedBackButtonRoutes.includes(source) && isFtEnabled) {
    query.from = source;
  } else if (!isFtEnabled) {
    query.inbox = conversationId;
  }

  dispatch(operations.highlightMessage(null));
  dispatch(operations.dismissReplyToMessage());
  dispatch(
    push({
      pathname,
      ...(Object.keys(query).length > 0 && { query }),
    })
  );
};

export default selectConversation;
